module.exports = __webpack_public_path__ + "img/image00004-min.b5359fe4.jpeg";